module.exports = __webpack_public_path__ + "img/graph-vehicles.44a78bcf.svg";